import axios from 'axios'
import { AuthService } from "@/services/auth.service";
import { AbstractService } from "./abstract.service";
import $store from "@/state/store"
import FileDownload from "js-file-download";
import moment from "moment";

export class SupplierServices extends AbstractService {

  static get entity() {
    return "nsh/partner/api"
  }

  static get URL_GATEWAY() {
    return process.env.VUE_APP_GATEWAY_API_URL;
  }

  static async getListSupplier(params) {
    try {
      const response = await await this.callApi().post(
        `${this.entity}/partners/suppliers`, params
      );
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }

  static async createrSupplier(params) {
    try {
      const response = await axios.post(
        `${this.URL_GATEWAY}/${this.entity}/partners/suppliers/create`,
        params,
        {
          headers: {
            Authorization: `Bearer ${AuthService.getBearer()}`,
            "np-merchant-id": params.merchantId,
            "np-app-id": process.env.VUE_APP_ID,
            "np-location-id": $store.state.auth.currentLocation
          }
      })
      return response.data
    } catch (error) {
      console.log(error);
    }
  }

  static async createNewShipper(params) {
    try {
      const response = await axios.post(
        `${this.URL_GATEWAY}/${this.entity}/partners/shippers/create`,
        params,
        {
          headers: {
            Authorization: `Bearer ${AuthService.getBearer()}`,
            "np-merchant-id": params.merchantId,
            "np-app-id": process.env.VUE_APP_ID,
            "np-location-id": $store.state.auth.currentLocation
          }
      })
      return response.data
    } catch (error) {
      console.log(error);
    }
  }

  static async getSupplierById(params) {
    try {
      const response = await await this.callApi().post(
        `${this.entity}/partners/detail`, params
      );
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }

  static async updateSupplier(params) {
    try {
      const response = await axios.put(
        `${this.URL_GATEWAY}/${this.entity}/partners/suppliers/edit/${params.id}`,
        params,
        {
          headers: {
            Authorization: `Bearer ${AuthService.getBearer()}`,
            "np-merchant-id": params.merchantId,
            "np-app-id": process.env.VUE_APP_ID,
            "np-location-id": $store.state.auth.currentLocation
          }
      })
      return response.data
    } catch (error) {
      console.log(error);
    }
  }

  static async deleteSupplier(params) {
    try {
      const response = await await this.callApi().put(
        `${this.entity}/partners/suppliers/delete`, params
      );
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }

  static async getGroupSupplier(params) {
    try {
      const response = await await this.callApi().post(
        `${this.entity}/groups/suppliers`, params
      );
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }

  static async createGroup(params) {
    try {
      const response = await await this.callApi().post(
        `${this.entity}/groups/suppliers/create`, params
      );
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }

  static async editGroup(params) {
    try {
      const response = await await this.callApi().put(
        `${this.entity}/groups/suppliers/edit/${params.id}`, params
      );
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }

  static async deleteGroup(params) {
    try {
      const response = await await this.callApi().put(
        `${this.entity}/groups/suppliers/delete`, params
      );
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }

  static async exportData(params) {
    try {
      const response = await await this.callApi().post(
        `${this.URL_GATEWAY}/nsh/imexport/api/partner/export/suppliers`, params, {responseType: 'blob'}
      )

      FileDownload(response.data, 'Report-suppliers' + ' ' + moment(new Date(new Date())).format('DD/MM/YYYY') + '.xlsx')

      return this.responseWrapper(response, response);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }

  static async importData(params) {
    try {
      const response = await await this.callApi().post(
        `${this.URL_GATEWAY}/nsh/imexport/api/partner/import/suppliers`, params
      )
      return this.responseWrapper(response, response);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }

  static async groupsSearch(params) {
    try {
      const response = await await this.callApi().post(
        `${this.entity}/groups/search`, params
      )
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }
}
